// extracted by mini-css-extract-plugin
export default {"copyNote":"_2kM466_10iFQEM7CL4czWF","blink":"_1Fjt3sFcbDXdd9I5JFaOZH"};